import { Line } from "../../../themed/charts";

import Conditional from "../../../common/conditional";

interface PDFGraphProps {
  data: { labels: string | string[]; datasets: any[] };
}

const PDFGraphPage = (props: PDFGraphProps) => {
  return (
    <Conditional isVisible={props.data.datasets.length > 0}>
      <Line chartData={props.data} />
    </Conditional>
  );
};

export default PDFGraphPage;
